import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that automatically scrolls to the top of the page
 * whenever the route changes. This improves UX by ensuring users always
 * start at the top of a new page instead of maintaining scroll position.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll the window to top
    window.scrollTo(0, 0);

    // Also scroll any scrollable main containers (for layouts with overflow-y-auto)
    const mainElements = document.querySelectorAll('main');
    mainElements.forEach(main => {
      main.scrollTo(0, 0);
    });
  }, [pathname]);

  return null;
};
